import type { MailboxInfo } from 'owa-client-types';
import getUserConfiguration from '../actions/getUserConfiguration';
import { getAccountScopeUserSettings } from './getAccountScopeUserSettings';

export default function getUserDisplayName(mailboxInfo?: MailboxInfo): string | undefined {
    if (mailboxInfo) {
        return getAccountScopeUserSettings(mailboxInfo).SessionSettings?.UserDisplayName;
    }
    return getUserConfiguration().SessionSettings?.UserDisplayName;
}
